import { MdMsgBox } from 'mdesign-plus';

export const useFailMsgBox = (message, callback) => {
    MdMsgBox({
        message,
        type: 'error',
        iconClass: 'md-icon-circle-close',
        title: '',
        // customClass: 'md-messagebox confirm',
        confirmButtonText: 'OK',
        showClose: true,
        center: true,
        closeOnClickModal: false,
        lockScroll: false,
        callback,
    });
}

// 挂载到 window 对象
if (typeof window !== 'undefined') {
    window.useFailMsgBox = useFailMsgBox;
}